import request from '../../axios';

const getLoanValidationPrice = async () => {
  const {data}: {data: {price: number}} = await request.get(
    `api/v2/payment/summary-loan-validation-request`,
  );
  return data.price;
};

export default getLoanValidationPrice;
